import React, { useState, useEffect, use } from "react";
// import { BASE_URL } from "../_globalConstants.js";

export default function AdminEdit() {
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(true);

    const [orgData, setOrgData] = useState([]);
    const [selectedOrg, setSelectedOrg] = useState(null);

    useEffect(() => {
        if (successMessage) {
            setTimeout(() => setSuccessMessage(false), 3000);
        }
        if (errorMessage) {
            setTimeout(() => setErrorMessage(false), 3000);
        }
    }, [successMessage, errorMessage]);

    useEffect(() => {
            // Fetch the organization data when the component mounts
            async function fetchOrganizationData() {
                setLoading(true);
                try {
                    const response = await fetch("/api/admin/company", {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                        }
                    });
                    // console.log("Response from server:", response);
                    if (response.ok) {
                        const data = await response.json();
                        setOrgData(data.results || data);
                    } else {
                        setErrorMessage("Failed to fetch organization data.");
                    }
                } catch (error) {
                    console.error("Failed to fetch organization data.", error);
                    setErrorMessage("Failed to fetch organization data.");
                }
                setLoading(false);
            }
            fetchOrganizationData();
        }, []);

    async function updateOrganization(e) {
        // This function should make a POST request to the backend
        // to create a new organization. 

        e.preventDefault();

        const org_stub = {
            company_name: document.getElementById("name").value,
            company_primary_poc: document.getElementById("poc_name").value,
            company_primary_poc_email: document.getElementById("poc_email").value,
        }

        try {
            company_id = selectedOrg ? selectedOrg.company_id : null;
            const response = await fetch("/api/admin/company/" + company_id, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(org_stub),
            });

            if (response.ok) {
                alert("Organization updated successfully!");
                // Clear the form
                document.getElementById("name").value = "";
                document.getElementById("poc_name").value = "";
                document.getElementById("poc_email").value = "";
            } else {
                // alert("Failed to create organization.");
                const error = await response.text();
                setErrorMessage(error || "Failed to update organization.");
            }
        } catch (error) {
            console.error("Failed to update organization.", error);
            setErrorMessage("Failed to update organization.");
        }
    }

    function Popup({ message, onClose, error }) {
        return (
            <div className={error ? "popup error-popup" : "popup success-popup"}>
                <div className="popup-content">
                    <p>{message}</p>
                    <span className="close" onClick={onClose}>&times;</span>
                </div>
            </div>
        );
    }

    const stepsComponent = () => {
        // This component returns either a list of organizations or a form to edit the selected organization
        return (
            <div className="org-edit-container">
                {!selectedOrg && (
                    <div className="org-list">
                        {orgData.map((org, index) => (
                            <div
                                key={index}
                                className={`org-item ${selectedOrg && selectedOrg.company_id === org.company_id ? "selected" : ""}`}
                                onClick={() => setSelectedOrg(org)}
                            >
                                {org.company_name}
                            </div>
                        ))}
                    </div>
                )}
                {selectedOrg && (
                    <div>
                        <button onClick={() => setSelectedOrg(null)} 
                            className="back-button">
                                Back
                        </button>

                        <form onSubmit={updateOrganization} 
                            className="org-edit-form">
                            <h3>Edit Organization</h3>
                            <label>
                                Name:
                                <input type="text" 
                                    id="name" 
                                    defaultValue={selectedOrg.company_name} 
                                    required />
                            </label>
                            <label>
                                Primary POC:
                                <input type="text" 
                                id="poc_name" 
                                defaultValue={selectedOrg.company_primary_poc} 
                                required />
                            </label>
                            <label>
                                Email:
                                <input type="email" 
                                id="poc_email" 
                                defaultValue={selectedOrg.company_primary_poc_email} 
                            required />
                            </label>
                            <button type="submit">Update Organization</button>
                        </form>
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className="admin-create-container">
            {loading &&
                <div>
                    Loading...
                </div>
            }
            {successMessage && <Popup message={successMessage} onClose={() => setSuccessMessage(false)} error={false} />}
            {errorMessage && <Popup message={errorMessage} onClose={() => setErrorMessage(false)} error={true} />}
                
            {stepsComponent()}

            {/* DEBUGGING */}
            {/* <div>{JSON.stringify(orgData)}</div> */}
        </div>
    );
    }